<template>
  <article class="tcs" :class="{ 'tcs--rec': tarif.empfehlung_type > 0 }">
    <div v-if="tarif.empfehlung_type > 0" class="tcs__rec-banner">
      <span v-if="tarif.empfehlung_type == 3"
        >Empfehlung · Beste Leistung</span
      >
      <span v-else>Empfehlung · Sehr gute Alternative</span>
    </div>

    <header class="tcs__head">
      <div class="tcs__title">
        <h2 class="tcs__name">{{ tarif.un_name }}</h2>
        <div class="tcs__meta">{{ tarif.tarif_title }}</div>
      </div>

      <div class="tcs__rank">
        <RankInfo :showMobile="true" :tarif="tarif" :berechnung="berechnung" />
      </div>

      <div class="tcs__price">
        <span class="tcs__price-num">{{ tarif.preis_value }}&nbsp;€</span>
        <span class="tcs__price-unit">mtl.</span>
      </div>
    </header>

    <div v-if="tarif.showBap == 1" class="tcs__bap">
      <v-icon icon="mdi-alert-outline" size="14" class="mr-1" color="error" />
      <strong>Hinweis Beitragserhöhung:</strong>
      {{ tarif.tarif_bap_hinweis }}
    </div>

    <div v-if="tarif.spezialHinweis" class="tcs__bap">
      <v-icon icon="mdi-alert-outline" size="14" class="mr-1" color="error" />
      <strong>Wichtiger Hinweis:</strong>
      {{ tarif.spezialHinweis }}
    </div>

    <div class="tcs__body">
      <HighlightsTarif class="tcs__hl" :tarif="tarif" />

      <ul class="tcs__list">
        <li v-for="(item, index) in filteredItems" :key="index">
          <v-icon
            icon="mdi-check"
            size="14"
            color="success"
            class="mr-1 tcs__list-check"
          />
          <span>{{ item.value }}</span>
        </li>
      </ul>

      <a
        class="tcs__link"
        @click="berechnungStore.setShowPop(tarif, 'tarifbeschreibung')"
      >
        Tarifbeschreibung →
      </a>
    </div>

    <footer class="tcs__foot" v-if="tarif.antraglink">
      <v-btn
        :to="tarif.antraglink"
        :color="berechnung.fontColorVue"
        variant="flat"
        rounded="0"
        block
        class="tcs__btn"
      >
        <v-icon icon="mdi-file-document-outline" size="16" class="mr-1" />
        Infopaket anfordern
      </v-btn>
      <div v-if="berechnung.ber_segment <= 1" class="tcs__hint">
        <v-icon icon="mdi-shield-check-outline" size="13" class="mr-1" />
        Clearment Vertragsschutz kostenlos inkl.
      </div>
    </footer>
  </article>
</template>

<script setup>
  import { defineProps, computed } from "vue";
  import RankInfo from "@/components/tarif/mini/RankInfo";
  import HighlightsTarif from "@/components/tarif/mini/HighlightsTarif";
  import { useBerechnungStore } from "@/stores/berechnung";

  const berechnungStore = useBerechnungStore();

  const props = defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });

  const filteredItems = computed(() => {
    let sortType = "erwachsen";
    if (
      props.berechnung.ber_algo_view == 2 &&
      props.berechnung.ber_segment == 1
    ) {
      sortType = "kind";
    }
    return (props.tarif.miniLeistungsLog || []).filter(
      (item) => item.type === sortType
    );
  });
</script>

<style scoped>
  .tcs {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    margin: 0 0 12px;
    position: relative;
  }

  .tcs--rec {
    border-color: #ffd166;
    border-left: 3px solid #f6a800;
  }
  .tcs--rec .tcs__head {
    background: #fffbe6;
    border-bottom-color: #ffe58f;
  }
  .tcs__rec-banner {
    display: flex;
    align-items: center;
    background: #f6a800;
    color: #ffffff;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.1px;
    text-transform: uppercase;
    padding: 4px 10px;
  }
  .tcs__rec-banner .v-icon {
    color: #ffffff;
  }

  .tcs__head {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 10px;
    align-items: center;
    padding: 10px 12px;
    background: #fafbfd;
    border-bottom: 1px solid #eef1f6;
  }
  .tcs__rank {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tcs__title {
    min-width: 0;
    text-align: left;
  }
  .tcs__name {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.1px;
    line-height: 1.2;
    word-break: break-word;
  }
  .tcs__meta {
    font-size: 11.5px;
    color: #6b7280;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tcs__price {
    text-align: right;
    white-space: nowrap;
  }
  .tcs__price-num {
    display: block;
    font-size: 18px;
    font-weight: 800;
    color: #0f4c81;
    letter-spacing: -0.3px;
    font-variant-numeric: tabular-nums;
    line-height: 1;
  }
  .tcs__price-unit {
    font-size: 11px;
    color: #6b7280;
  }

  .tcs__bap {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    background: #fff5f0;
    border-top: 1px solid #f5c4ba;
    border-bottom: 1px solid #f5c4ba;
    border-left: 3px solid #c62828;
    padding: 8px 12px;
    font-size: 12.5px;
    color: #b3261e;
    line-height: 1.4;
  }

  .tcs__body {
    padding: 10px 12px 6px;
  }
  .tcs__hl {
    margin-bottom: 6px;
  }
  .tcs__list {
    list-style: none;
    padding: 0;
    margin: 0 0 6px;
    font-size: 13px;
    color: #1f2937;
  }
  .tcs__list li {
    display: flex;
    align-items: flex-start;
    padding: 2px 0;
    line-height: 1.35;
  }
  .tcs__list-check {
    margin-top: 2px;
  }
  .tcs__link {
    display: inline-block;
    font-size: 12.5px;
    color: #0f4c81;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }
  .tcs__link:hover {
    text-decoration: underline;
  }

  .tcs__foot {
    padding: 10px 12px 12px;
    border-top: 1px solid #eef1f6;
  }
  .tcs__btn {
    border-radius: 3px !important;
    height: 44px !important;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-transform: none;
    color: #ffffff !important;
  }
  .tcs__hint {
    font-size: 11.5px;
    color: #6b7280;
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
</style>
